import Svg, { G, Path } from 'react-native-svg'

export const VisaIcon = ({ height, width }: { height: any; width: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 40 24">
      <G transform="translate(-3493 -13906)">
        <Path transform="translate(3493 13906)" d="M0 0H40V24H0z" fill="#fff" opacity={0} />
        <Path
          d="M3510.939 13922.833h-2.53l1.581-9.661h2.53zm-4.658-9.661l-2.407 6.645-.285-1.431-.851-4.345a1.081 1.081 0 00-1.2-.87h-3.991l-.047.164a9.494 9.494 0 012.646 1.1l2.2 8.393h2.636l4.024-9.661zm19.9 9.661h2.323l-2.03-9.661h-2.032a1.162 1.162 0 00-1.168.72l-3.773 8.941h2.637l.527-1.435h3.216zm-2.787-3.417l1.329-3.615.748 3.615zm-3.695-3.92l.361-2.075a7.337 7.337 0 00-2.275-.421c-1.255 0-4.236.546-4.236 3.2 0 2.5 3.5 2.527 3.5 3.838s-3.138 1.076-4.174.249l-.376 2.169a7.122 7.122 0 002.855.546c1.726 0 4.33-.889 4.33-3.308 0-2.512-3.53-2.746-3.53-3.838s2.464-.952 3.546-.359z"
          fill="#2566af"
        />
      </G>
    </Svg>
  )
}
